import { Injectable, inject } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { OrchestrationAccessService } from '@services/orchestration-access.service';
import { Observable, of } from 'rxjs';

/**
 * Who may start a satellite processing request from the map. Mirrors the server
 * `OrchestrationAdmin` policy on `POST /assignments/processes/{processKey}`: the `Admin` role,
 * or the global `orchestration.admin` permission.
 */
@Injectable({ providedIn: 'root' })
export class MapRequestAccessService {
  private readonly auth = inject(AuthService);
  private readonly orchestrationAccess = inject(OrchestrationAccessService);

  /** Emits once whether the signed-in user is allowed to see the map request action. */
  canCreateRequest(): Observable<boolean> {
    if (this.auth.isAdmin()) {
      return of(true);
    }
    return this.orchestrationAccess.hasOrchestrationAdmin();
  }
}
